import moment from 'moment'
import React from 'react'
import InfoSection from './info-section'
import { useTranslation } from 'react-i18next';
import { COURSE_LECTURES_LECTURE_DATE_LABEL, COURSE_LECTURES_LECTURE_TIME_LABEL, COURSE_LECTURES_NO_LECTURES } from '../../../../i18n/keyConstants';


export default function CourseLectures({ course }) {

  const { t } = useTranslation('courseLectures');

  const getLectureDateDisplay = (startTime, endTime) => {
    moment.locale(localStorage.getItem('userLocale'));
    var formattedStartTime = moment.utc(startTime).local().format();
    var formattedEndTime = moment.utc(endTime).local().format();

    return `${formattedStartTime.substring(11, 16)}  - ${formattedEndTime.substring(11, 16)}`;
  }

  if (course?.lectures?.length < 1) {
    return (
      <div style={{ color: "grey" }}>{t(COURSE_LECTURES_NO_LECTURES)}</div>
    )
  } 

  return (
    <div>
      {course?.lectures.map((lecture) => (
        <div className={"d-flex card ml-auto p-2 mb-2 list-card"}  key={lecture.id}>
          <a href={`/exlLectureDetails/${lecture.id}`}>
            <h4 style={{marginBottom: "1.0rem"}}>{lecture.name} </h4>
          </a>

          <div style={{ display: "flex" }}>
            <div style={{ marginRight: "1rem" }}>
                      <InfoSection marginBottom="0px" sectionLabel={t(COURSE_LECTURES_LECTURE_DATE_LABEL)} >
                {moment.utc(lecture.startTime).local().format('YYYY-MM-DD')}
              </InfoSection>
            </div>
            <div>
                      <InfoSection marginBottom="0px" sectionLabel={t(COURSE_LECTURES_LECTURE_TIME_LABEL)} >
                {<div style={{ whiteSpace: "nowrap" }}>{getLectureDateDisplay(lecture.startTime, lecture.endTime)}</div>}
              </InfoSection>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
